import Table from '../../components/ui/Table'
import Badge from '../../components/ui/Badge'
import Dropdown from '../../components/ui/Dropdown'
import { formatDate } from '../../lib/format'

function UserRow({ user, onUpdateRole, onEdit, onDelete, isCurrentUser }) {
  const initials = (user.name || user.email || 'U')
    .substring(0, 2)
    .toUpperCase()

  const roleBadge = user.role === 'admin'
    ? <Badge variant="active">Admin</Badge>
    : <Badge variant="planning">Member</Badge>

  return (
    <Table.Row>
      <Table.Cell>
        <div className="flex items-center gap-3">
          <div
            style={{
              width: '36px',
              height: '36px',
              borderRadius: '50%',
              background: 'var(--gradient-primary)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 600,
              fontSize: '0.875rem',
            }}
          >
            {initials}
          </div>
          <div>
            <div className="font-medium">{user.name || 'Unnamed'}</div>
            {isCurrentUser && (
              <span className="text-xs text-muted">(You)</span>
            )}
          </div>
        </div>
      </Table.Cell>
      <Table.Cell>
        <span className="text-muted">{user.email}</span>
      </Table.Cell>
      <Table.Cell>
        {roleBadge}
      </Table.Cell>
      <Table.Cell>
        {formatDate(user.created_at)}
      </Table.Cell>
      <Table.Cell>
        {!isCurrentUser && (
          <Dropdown
            trigger={<button className="btn btn-ghost btn-sm">⋯</button>}
          >
            <Dropdown.Item onClick={() => onEdit(user)}>
              ✏️ Edit User
            </Dropdown.Item>
            {user.role === 'admin' ? (
              <Dropdown.Item onClick={() => onUpdateRole(user.id, 'member')}>
                👤 Make Member
              </Dropdown.Item>
            ) : (
              <Dropdown.Item onClick={() => onUpdateRole(user.id, 'admin')}>
                👑 Make Admin
              </Dropdown.Item>
            )}
            <Dropdown.Divider />
            <Dropdown.Item onClick={() => onDelete(user)} danger>
              🗑️ Delete User
            </Dropdown.Item>
          </Dropdown>
        )}
      </Table.Cell>
    </Table.Row>
  )
}

export default UserRow
